import React from 'react'
import { ResponsivePropClassNameMap, lit } from 'src/utils'
import {
    DirectionOption,
    buildResponsivePropDependentClassNames,
} from './shared'
import { CardContext } from './CardContext'

// spacing classes depend on the `direction` of the card (horizontal or vertical)
const SPACING_CLASSES: ResponsivePropClassNameMap<DirectionOption> = {
    base: {
        vertical: 'mb-2 mr-0',
        horizontal: 'mr-2 mb-0',
    },
    '2xs': {
        vertical: '2xs:mb-2 2xs:mr-0',
        horizontal: '2xs:mr-2 2xs:mb-0',
    },
    md: {
        vertical: 'md:mb-4 md:mr-0',
        horizontal: 'md:mr-4 md:mb-0',
    },
}

export interface CardHeaderProps {
    className?: string
    children: React.ReactNode
}

export function CardHeader({ className, children }: CardHeaderProps) {
    const { direction, spacing } = React.useContext(CardContext)
    const spacingClassNames =
        spacing === 'medium'
            ? buildResponsivePropDependentClassNames<DirectionOption>(
                  SPACING_CLASSES,
                  direction
              )
            : ''

    return (
        <header
            className={lit`${spacingClassNames} min-h-0 min-w-0 ${className}`}
        >
            {children}
        </header>
    )
}
